
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const UpdateProduct = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_UPDATE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PRODUCT_UPDATE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'PRODUCT_UPDATE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'PRODUCT_UPDATE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default UpdateProduct